import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';
import { resetBook, setCurrentBook } from '../../../store/BookSlice';
import { Frame } from '../../_molecules/Frame';
import { ImageButton } from '../../_molecules/ImageButton';

export const MainTemplate = (props) => {
  const dispatch = useDispatch();

  const onClickBook = (idx) => {
    dispatch(setCurrentBook(idx));
    dispatch(resetBook());
    
    window.location.hash="#/menu/" + (idx + 1);
  };

  return (
    <Frame type='bookMenu'>
      {props.menu && props.menu.map((book, idx) => {
        return <ImageButton type='bookMenu' src={book.src} idx={idx} alt={book.alt} onClick={() => onClickBook(idx)}/>
      })}
    </Frame>
  );
};

MainTemplate.propTypes = {
  menu : PropTypes.array.isRequired
};

MainTemplate.defaultProps = {
  menu : [
    {
      src : 'https://content.chungchy.com/PhonicsHero/web_resource/images/main/phonics_pop_book1.png', 
      alt : 'Phonics Pop Book1'
    },
    {
      src : 'https://content.chungchy.com/PhonicsHero/web_resource/images/main/phonics_pop_book2.png', 
      alt : 'Phonics Pop Book2'
    },
    {
      src : 'https://content.chungchy.com/PhonicsHero/web_resource/images/main/phonics_pop_book3.png', 
      alt : 'Phonics Pop Book3'
    },
  ]
};